import { IDayCell } from '../services/calendar'
import { CalendarSystem } from '../services/settings'
import { J_WEEKDAYS, G_WEEKDAYS, J_MONTHS, G_MONTHS_EN } from '../configs/names'
import { toFaDigits } from './digits'
import { solarYear } from './year'

// The same day in two halves, split where the day page breaks its title: the
// weekday with the day number, then the month with the year.
export const dayLineParts = (day: IDayCell & { wd: number }, system: CalendarSystem) =>
    system === 'gregorian'
        ? [`${G_WEEKDAYS[day.wd]} ${day.gd}`, `${G_MONTHS_EN[day.gm - 1]} ${day.gy}`]
        : [`${J_WEEKDAYS[day.wd]} ${toFaDigits(day.jd)}`, `${J_MONTHS[day.jm - 1]} ${solarYear(day.jy)}`]

// A day written out in full — weekday, day, month, year — in the active
// calendar. How the occasion page names the day it is adding to, and what a
// reminder says, so every place spells the day the same way.
export const dayLine = (day: IDayCell & { wd: number }, system: CalendarSystem) =>
    dayLineParts(day, system).join(' ')
